import { Component, inject } from "@angular/core";
import { ImagePreviewService } from "../../core/image-preview.service";
import { isVideoAttachment } from "../../core/attachment-media";

@Component({
    selector: 'app-image-preview',
    standalone: true,
    template: `
    @if(preview.isOpen()) {
        <div class="overlay" (click)="preview.close()">
            <div class="popup" (click)="$event.stopPropagation()">
                <button
                    class="close-btn material-symbols-outlined" 
                    (click)="preview.close()"
                >close</button>

                <div class="img-wrapper">
                    <h3 class="image-title">Image{{ preview.currentIndex() + 1 }}</h3>
                    @if(isVideo(preview.images()[preview.currentIndex()])) {
                        <video [src]="preview.images()[preview.currentIndex()]" controls playsinline autoplay></video>
                    } @else {
                        <img [src]="preview.images()[preview.currentIndex()]" />
                    }
                </div>

                @if(preview.currentIndex() < preview.images().length - 1) {
                    <button 
                        class="control-button prev material-symbols-outlined" 
                        (click)="preview.next()"
                    >keyboard_arrow_left</button>
                }
                @if(preview.currentIndex() !== 0) {
                    <button
                        class="control-button next material-symbols-outlined" 
                        (click)="preview.prev()"
                    >keyboard_arrow_right</button>
                }
            </div>
        </div>
    }
  `,
    styleUrl: './image-preview.scss',
})
export class ImagePreviewComponent {
    preview = inject(ImagePreviewService);
    
    isVideo(url: string): boolean {
        return isVideoAttachment(url);
    }
}